import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import * as Yup from "yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
    editRegistration,
    Section7Get,
    Section7Post,
} from "../../../Store/auth/register";
import { Form, Formik, useFormik } from "formik";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import { enqueueSnackbar } from "notistack";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import Loading from "../../../Components/Loader/Loading";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ModalComp from "../../../Components/ModalComp";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const Section7 = ({ setSubTabs }) => {
    // handling success and errors
    const [isModalOpen, setIsModalOpen] = useState(false);
    const gsn_no = localStorage.getItem("gsn_no");
    const application_no = localStorage.getItem("RegKey");
    const DBName = localStorage.getItem("Db_name");
    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: "Section7Questions",
        queryFn: () =>
            Section7Get(
                application_no && DBName ? DBName : "Pending DB",
                application_no
            ),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
    });
    if (!application_no) {
        setSubTabs({ "Get Started": true });
    }
    // validation for fields
    const modelSchema = Yup.object().shape({
        ...questions?.documents?.reduce((schema, fields) => {
            if (fields?.type.toLowerCase() !== "section") {
                // Define validation rules
                let fieldValidation = Yup;

                // Apply different validation rules based on the field's validation type
                if (
                    fields.validation.toLowerCase() === "email" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation
                        .string()
                        .email("Invalid email address");
                } else if (fields.validation.toLowerCase() === "pan") {
                    fieldValidation = fieldValidation
                        .string()
                        .matches(
                            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                            "Invalid PAN Number. It should be in the format: ABCDE1234F."
                        );
                } else if (fields.type.toLowerCase() === "multiselect dropdown") {
                    fieldValidation = fieldValidation.array();
                } else if (fields.validation.toLowerCase() === "pincode") {
                    fieldValidation = fieldValidation
                        .string()
                        .matches(/^\d{4}$|^\d{6}$/, "PIN code must be exactly 6 digits");
                } else if (fields.validation.toLowerCase() === "darpan") {
                    fieldValidation = fieldValidation
                        .string()
                        .test(
                            "is-valid-darpan",
                            " Darpan Id should be in the format: XX/1234/1234567",
                            (value) => {
                                if (value?.toUpperCase() === "NA") {
                                    return true;
                                }
                                return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
                            }
                        );
                } else if (
                    fields.validation.toLowerCase() === "password" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation
                        .string()
                        .min(8, "Password must be at least 8 characters long");
                }

                // Apply required validation if the field is mandatory
                if (fields.mandatory === 1) {
                    fieldValidation = fieldValidation.required(
                        `${fields.question} is required`
                    );
                }

                // Assign the validation rule to the field in the schema
                schema[fields?.question_no] = fieldValidation;
            }

            return schema;
        }, {}),
    });

    const formik = useFormik({
        initialValues: questions?.documents?.reduce((values, fields) => {
            // Check if there's an answer for the current question_no

            const answer =
                questions?.docs_answers.length > 0
                    ? questions?.docs_answers?.find(
                        (ans) => ans.question_no === fields.question_no
                    )
                    : "";

            if (
                (answer?.answer &&
                    fields.type.toLowerCase() !== "section" &&
                    questions?.docs_answers.length > 0) ||
                (answer?.upload_document &&
                    questions?.docs_answers.length > 0 &&
                    fields.type.toLowerCase() !== "section")
            ) {
                if (fields.type.toLowerCase() === "checkbox") {
                    values[fields?.question_no] = answer?.answer === "Y" ? true : false; // Initialize with the answer if available
                } else if (fields.type.toLowerCase() === "multiselect dropdown") {
                    values[fields?.question_no] = answer?.answer.split(",");
                } else {
                    values[fields?.question_no] = answer?.answer || {
                        fileName: answer?.upload_document,
                    }; // Initialize with the answer if available
                }
            } else {
                values[fields?.question_no] = ""; // Default to an empty string if no answer exists
            }

            return values;
        }, {}),
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const tempData = questions?.documents?.map((fields) => {
                    if (
                        fields?.type.toLowerCase() === "attach" &&
                        values?.[fields.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            attach_file: values?.[fields?.question_no]?.file64,
                            file_name: values?.[fields?.question_no]?.fileName,
                        };
                    } else if (
                        fields?.type.toLowerCase() === "multiselect dropdown" &&
                        values?.[fields?.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no].map((ele) => {
                                return ele;
                            })}`,
                        };
                    } else {
                        return {
                            question_no: fields?.question_no,
                            answer: values[fields?.question_no],
                        };
                    }
                });
                const structuredData = {
                    args: {
                        name: application_no,
                        discover_registration_section_7: tempData,
                    },
                };

                await submitMainForm(structuredData);
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    // file handling manually

    const fileHandler = (e) => {
        const file = e?.target?.files[0];
        const name = e?.target?.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formik.setFieldValue(name, {
                    file64: base64String,
                    fileName: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // error handling mutation

    const handleCreateSuccess = () => {
        setTimeout(() => {
            setSubTabs({ Undertaking: true });
        }, 1000);
        enqueueSnackbar("success!", { variant: "success" });
    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500) {
            enqueueSnackbar(error?.response?.data?.status_message, {
                variant: "error",
            });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, {
                variant: "error",
            });
        }
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };

    // checking table fields manually

    // handle the conditions in backend data

    const evaluateCondition = (value1, condition, value2) => {
        switch (condition) {
            case "==":
                return value1 == value2; // Using loose equality as per original suggestion
            case "===":
                return value1 === value2;
            case "!==":
                if (value1 !== value2) {
                    return false;
                }
            case ">":
                return value1 > value2;
            case "<":
                return value1 < value2;
            case ">=":
                return value1 >= value2;
            case "<=":
                return value1 <= value2;
            default:
                return false;
        }
    };

    // submit form

    const { mutate: submitMainForm, isPending: mainRegistration } = useMutation({
        mutationFn: Section7Post,
        ...createFarmerMutationOptions,
    });

    // waiting for fields 

    const editModalSchema = Yup.object().shape({
        [isModalOpen?.data?.question_no]: (() => {
            let validation = Yup.string();

            // Check if isModalOpen?.data is defined
            if (!isModalOpen?.data) return validation;

            const fieldType = isModalOpen.data.type?.toLowerCase();
            const fieldValidation = isModalOpen.data.validation?.toLowerCase();

            // Apply validation based on `validation` property
            if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
                validation = validation.matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Invalid email address"
                );
            } else if (fieldValidation === "pan") {
                validation = validation.matches(
                    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    "Invalid PAN Number. Format: ABCDE1234F."
                );
            } else if (fieldValidation === "pincode") {
                validation = validation.matches(
                    /^\d{4}$|^\d{6}$/,
                    "PIN code must be exactly 4 or 6 digits"
                );
            } else if (fieldValidation === "mobile") {
                validation = validation.matches(
                    /^(?:[0-9]{10}|[0-9]{7})$/,
                    "Invalid contact number"
                );
            } else if (fieldValidation === "website") {
                validation = validation.url("Please enter a valid URL");
            } else if (fieldValidation === "darpan") {
                validation = validation.test(
                    "is-valid-darpan",
                    "Darpan ID should be in the format: XX/1234/1234567",
                    (value) =>
                        value?.toUpperCase() === "NA" ||
                        /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                );
            } else if (
                fieldValidation === "password" &&
                !isModalOpen.data?.depend_question
            ) {
                validation = validation.min(
                    8,
                    "Password must be at least 8 characters long"
                );
            } else if (fieldType === "multiselect dropdown") {
                validation = Yup.array().of(Yup.string());
            } else if (fieldType === "attach") {
                validation = Yup.object();
            }

            // Apply 'required' validation if `mandatory` is 1
            if (isModalOpen.data.mandatory === 1) {
                validation = validation.required(
                    `${isModalOpen.data.question} is required`
                );
            }

            return validation;
        })(),
    });

    const attachFile = (e, setFieldValue) => {
        if (!e.target.files || e.target.files.length === 0) {
            setFieldValue(e.target.name, "");
            return; // Prevent further execution if no file is selected
        }
        const file = e.target.files[0];
        const name = e.target.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                setFieldValue(name, {
                    attach_file: base64String,
                    file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // waiting for fields

    const commonEditOpenModal = (
        name,
        data,
        values,
        type,
        template,
        sub_question_num,
        subQuestion
    ) => {
        setIsModalOpen({
            [name]: true,
            data,
            values,
            type: type,
            template: template,
            sub_question_num: sub_question_num,
            subQuestion,
        });
    };

    const commonEditCloseModal = () => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    };

    console.log(
        "docs>>>",
        questions?.documents?.find((doc) => doc?.type?.toLowerCase() === "section")
            ?.template
    );
    const hasAnswerForQuestion = () => {
        if (!questions?.docs_answers?.length) return false;

        // Check if any document has at least one answer
        const hasAnyAnswer = questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)

        // Find a document matching any template from `questions.documents`
        const doc = questions.documents
            .map(template => questions.docs_answers.find(doc => doc?.template === template?.template))
            .find(Boolean); // Find the first matching document

        // Ensure `doc` exists and `doc.answer` is a valid array before checking answers
        const isAnyAnswerFilled = Array.isArray(doc?.answer) && doc.answer.some(ele =>
            Array.isArray(ele) && ele.some(dt => dt?.answer)
        );

        return isAnyAnswerFilled || hasAnyAnswer;
    };

    const updateValues = async (values) => {
        try {
            console.log("isModalOpen>>>>", isModalOpen);
            const currentDate = await new Date();
            let structuredData = "";
            if (isModalOpen?.type?.toLowerCase() === "section") {
                const PreviosData = questions?.docs_answers
                    ?.find((doc) => doc?.template === isModalOpen?.template)
                    ?.answer?.[isModalOpen?.index].find(
                        (ans) => ans.question_no === isModalOpen?.data.question_no
                    );
                structuredData = await {
                    args: {
                        gsn_number: gsn_no,
                        date_and_time: formatDateTime(currentDate),
                        gsi_id: application_no,
                        question_id: isModalOpen?.sub_question_num,
                        subquestion_id: isModalOpen?.data?.question_no,
                        subquestion_previous_answer: PreviosData?.answer,
                        subquestion_edited_answer:
                            isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown"
                                ? `${values?.[isModalOpen?.data?.question_no].map((ele) => {
                                    return ele;
                                })}`
                                : values?.[isModalOpen?.data?.question_no],
                        subquestion_text: isModalOpen?.data?.question,
                        question_text: isModalOpen?.subQuestion,
                        section_name: 'Discover Registration Details'
                    },
                };
            } else {
                structuredData = await {
                    args: {
                        gsn_number: gsn_no,
                        date_and_time: formatDateTime(currentDate),
                        gsi_id: application_no,
                        question_id: isModalOpen?.data?.question_no,
                        question_text: isModalOpen?.data?.question,
                        previous_answer:
                            values?.normalFields?.[isModalOpen?.data?.question_no] ||
                            (questions?.docs_answers?.length > 0 &&
                                questions?.docs_answers?.find(
                                    (doc) => doc?.question_no === isModalOpen?.data?.question_no
                                )?.answer) ||
                            "",
                        edited_answer:
                            isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown"
                                ? `${values?.[isModalOpen?.data?.question_no].map((ele) => {
                                    return ele;
                                })}`
                                : values?.[isModalOpen?.data?.question_no],
                        section_name: 'Discover Registration Details'
                    },
                };
            }
            console.log("structuredData>>>>", structuredData);

            await editData(structuredData);
        } catch (error) { }
    };
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);

        // Extract YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

        // Extract HH:MM:SS in 24-hour format
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const { mutate: editData, isPending: editLoading } = useMutation({
        mutationFn: editRegistration,
        ...createFarmerMutationOptions,
        onMutate: async () => {
            // Cancel the current query before mutating
            // await queryClient.cancelQueries(['Questions', application_no]);
        },
        onSuccess: () => {
            // Invalidate the query to refetch the latest data
            // queryClient.invalidateQueries(['Questions', application_no]);
        },
    });

    const modalMultiSelectedValues = (name, values, setModalFieldValue) => {
        setModalFieldValue(name, values);
    };

    useEffect(() => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    }, [editLoading]);

    if (mainRegistration || fieldLoading) return <Loading />;

    return (
        <>
            <form className='flex flex-col gap-[30px]' onSubmit={formik.handleSubmit} action="">
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {questions?.documents.map(Fields =>
                        <>
                            {Fields?.paremeter &&
                                <div className='w-[100%]'>
                                    <HeaderCompo className='text-2xl text-black' text={Fields?.paremeter} tagType='h3' />
                                </div>
                            }
                            {
                                Fields.question.toLowerCase() !== 'location on map' && Fields?.type.toLowerCase() === 'text' || Fields?.type.toLowerCase() === 'number' || Fields?.type.toLowerCase() === 'date' || Fields?.type.toLowerCase() === 'password' ?
                                    <div className={`${Fields.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 150 ? 'w-[100%]' : ' w-[48%]'} `}>
                                        <div>
                                            <CustomInput required={Fields?.mandatory > 0 ? true : false}
                                                // {...formik.getFieldProps(Fields.question_no)}
                                                type={Fields?.type.toLowerCase()}
                                                name={Fields.question_no} label={Fields.question}
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                        </div>
                                    </div >

                                    :
                                    Fields?.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 150 ? 'w-[100%]' : ' w-[48%]'}`}>

                                            <div className='flex gap-[10px]' >
                                                <div className='w-[100%]'>
                                                    <CustomSelection required={Fields?.mandatory > 0 ? true : false}
                                                        options={Fields?.options}
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no} label={Fields.question}
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                                </div>
                                                {questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer) &&gsn_no &&

                                                    <div className="flex gap-[10px] mt-[8px]">
                                                        <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                            <BorderColorIcon className="text-white" />
                                                        </div>
                                                        <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] relative h-fit rounded-full p-[8px]">
                                                            {
                                                                (questions?.docs_answers?.length > 0 &&
                                                                    questions?.docs_answers?.find(doc => doc?.question_no === Fields?.question_no)?.comments_for_npo)
                                                                &&
                                                                <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                                                    <NotificationsActiveIcon className=" text-[#ffffff]" />
                                                                </div>
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        :
                                        Fields?.type.toLowerCase() === 'checkbox' ?
                                            <div className=' w-[100%]'>
                                                <label className="flex mt-[16px] items-center space-x-2">
                                                    <InputCompo
                                                        required={Fields?.mandatory > 0 ? true : false}
                                                        disabled={questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)}
                                                        options={Fields?.options}
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no}
                                                        className='bg-[#004878]  text-white w-[20px] h-[20px]' type='checkbox' />
                                                    <span className='text-black'>{Fields.question}</span>
                                                </label>
                                            </div>
                                            :
                                            Fields?.type.toLowerCase() === 'multiselect dropdown' ?
                                                <div className=' w-[100%] flex gap-[10px]'>
                                                    <div className='w-[100%]' >
                                                        <MultipleSelect
                                                            disabled={questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)}
                                                            required={Fields?.mandatory > 0 ? true : false}
                                                            options={Fields?.options}
                                                            mappingKey="option" // Pass mapping key if needed
                                                            formik={formik} // Pass the formik instance
                                                            name={Fields.question_no}
                                                            label={Fields?.question}
                                                        />
                                                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                                    </div>
                                                    {questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer) &&gsn_no &&

                                                        <div className="flex gap-[10px] mt-[8px]">
                                                            <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                                <BorderColorIcon className="text-white" />
                                                            </div>
                                                            <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] relative h-fit rounded-full p-[8px]">
                                                            {
                                                                (questions?.docs_answers?.length > 0 &&
                                                                    questions?.docs_answers?.find(doc => doc?.question_no === Fields?.question_no)?.comments_for_npo)
                                                                &&
                                                                <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                                                    <NotificationsActiveIcon className=" text-[#ffffff]" />
                                                                </div>
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                        </div>
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                Fields.question.toLowerCase() === 'location on map' ?
                                                    <div className='w-[100%] flex gap-[24pt]'>
                                                        <div className='w-[100%]'>
                                                            <CustomInput required={Fields?.mandatory > 0 ? true : false}
                                                                options={Fields?.options}
                                                                type={Fields.question.toLowerCase()}
                                                                {...formik.getFieldProps(Fields.question_no)}
                                                                name={Fields.question_no} label='Location on Map'
                                                            />
                                                            <ParagraphComp className='mt-[8px] text-black text-sm px-[8px]' text={'Click the Locate icon to open map and pin location'} />
                                                        </div>
                                                    </div>
                                                    :

                                                    Fields?.type.toLowerCase() === 'attach' ?
                                                        <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.description?.length > 250 ? 'w-[100%]' : ' w-[48%]'}`}>
                                                            <div>
                                                                <>
                                                                    <CustomFileInput options={Fields?.options}
                                                                        required={Fields?.mandatory > 0 ? true : false}
                                                                        onChange={fileHandler}
                                                                        value={formik?.values?.[Fields?.question_no]?.fileName}
                                                                        name={Fields.question_no} label={Fields.question}
                                                                    />
                                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                              </>
                                                            </div>
                                                        </div>
                                                        : ''
                            }

                        </>
                    )}


                </div >
                {hasAnswerForQuestion() ? (
                    ""
                ) : (
                    <div className="flex justify-end">
                        <ButtonComp
                            type={"submit"}
                            className="px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full"
                            text="Save & Next"
                        />
                    </div>
                )}
            </form >
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={commonEditCloseModal} >
                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
                <ParagraphComp className='text-lg text-black text-center' >
                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                        ((questions?.docs_answers?.length > 0 &&
                            Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                        (questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
                </ParagraphComp>
                <div className="flex justify-end">
                    <ButtonComp onClick={commonEditCloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                        Close
                    </ButtonComp>
                </div>

            </ModalComp>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={commonEditCloseModal} >
                {console.log("isModalOpen>>>>>", isModalOpen)}
                <Formik
                    enableReinitialize
                    initialValues={{
                        [isModalOpen?.data?.question_no || 'default_question_no']: '',
                    }}
                    validationSchema={editModalSchema}
                    onSubmit={(values) => {
                        updateValues(values);
                    }}
                >


                    {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (

                        <Form action="">
                            <div className='h-auto'>
                                <div className='flex justify-end'>
                                    <div className='cursor-pointer' onClick={commonEditCloseModal}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                                <ParagraphComp className='text-lg text-black text-start' text='Question' />
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                                {(isModalOpen?.type?.toLowerCase() === 'section' ?
                                    formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                    (questions?.docs_answers?.length > 0 &&
                                        questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                                    formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                    (questions?.docs_answers?.length > 0 &&
                                        questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer))
                                    ?
                                    <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                                    : ''
                                }
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' >
                                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                                        formik?.values?.[isModalOpen?.template][isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                        (questions?.docs_answers?.length > 0 &&
                                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                                        formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                        (questions?.docs_answers?.length > 0 &&
                                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || ''}
                                </ParagraphComp>
                                {isModalOpen?.data?.type.toLowerCase() === 'text' || isModalOpen?.data?.type.toLowerCase() === 'number' || isModalOpen?.data?.type.toLowerCase() === 'date' || isModalOpen?.data?.type.toLowerCase() === 'password' ?
                                    < div className='mt-[20px]'>
                                        <CustomInput required={true}
                                            type={isModalOpen?.data?.type?.toLowerCase()}
                                            name={isModalOpen?.data?.question_no}
                                            value={modalValues?.[isModalOpen?.data?.question_no]}
                                            onChange={handleChange} label='New Answer' />
                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                    </div>
                                    :
                                    isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                                        < div className='mt-[20px]'>
                                            <CustomSelection
                                                imgKey='flag'
                                                exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                                                mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                                                options={isModalOpen?.data?.options}
                                                required={true}
                                                value={modalValues?.[isModalOpen?.data.question_no]}
                                                onChange={handleChange}
                                                name={isModalOpen?.data.question_no}
                                                label='New Answer'
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                        </div>
                                        : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                                            < div className='mt-[20px]'>
                                                <MultipleSelect
                                                    required={true}
                                                    options={isModalOpen?.data?.options
                                                    }
                                                    maxSelect={isModalOpen?.data.validation === 'Select Upto 3' && 3}
                                                    mappingKey={isModalOpen?.data?.question_no !== "DRQ-00077" ? "option" : 'option'} // Pass mapping key if needed
                                                    onValueChange={(name, values) => modalMultiSelectedValues(name, values, setModalFieldValue)}
                                                    selectedValues={modalValues?.[isModalOpen?.data?.question_no] || []}
                                                    name={isModalOpen?.data?.question_no}
                                                    label='New Answer'
                                                />
                                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />

                                            </div>
                                            :
                                            isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                                                <div className='mt-[20px]'>
                                                    <CustomFileInput
                                                        required={true}
                                                        onChange={(e) => attachFile(e, setModalFieldValue)}
                                                        value={modalValues?.[isModalOpen?.data?.question_no].file_name}
                                                        name={isModalOpen?.data?.question_no}
                                                        label="New Answer"
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                                </div>
                                                : ''

                                }

                                <div className="flex justify-center mt-[15px]">
                                    <ButtonComp
                                        disabled={editLoading ? true : false}
                                        className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                                        type="Submit"
                                        text={editLoading ? "Saving..." : "Save"}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalComp>
        </>
    );
};

export default Section7;
